module.exports = __webpack_public_path__ + "static/media/AnnotationIcon.86b61939.svg";